 <form #addUserForm="ngForm">

    <div class="modal-header">
      <h4>Add user</h4>
    </div>
    <div class="modal-body">
      <div class="add-name">
        <strong>User name</strong>
                
        <div class="typeahead-wrap" style="width:100%;">
          <i class="icon-ic_search"></i>
          <input type="text" class="lookup-input" minlength="3" [typeahead]="requestorNameDataSource"
            [typeaheadMinLength]="3" [typeaheadScrollable]="true" [typeaheadItemTemplate]= "requestorCustTemp"
            (typeaheadLoading)="changeRequestorTypeaheadLoading($event)" typeahead-focus-first=true
            (typeaheadOnSelect)="requestorNameOnSelect($event)" (typeaheadNoResults)="typeaheadTravelerNoResults($event)"
            [typeaheadOptionsInScrollableView]="5" typeaheadOptionField="EmployeeFullName" [(ngModel)]="EmployeeFullName"
            name="EmployeeFirstName" #requestorName="ngModel" id="requestorName" autocomplete="off"  [ngModelOptions]="{standalone: true}"
            placeholder="Enter user's name" (keyup)="searchClient(EmployeeFullName)" required>
            <span ng-bind="EmployeeFullName"></span>
            
      <!-- <div class="search-result" *ngIf="flag">
        <ul>
          <li *ngFor="let client of ClientName">
            <a (click)="onselectClient(client)">{{client.displayName}}
              <br>
              <span>{{client.mail}}</span>
            </a>
          </li>
        </ul>
        </div> -->
          
          <img src="../assets/images/spinner.gif" *ngIf="typeaheadRequestorLoading" class="loader">
          <div class="alert alert-danger" style="position: absolute;" [hidden]="!noResultTravelerName">No results found
          </div>
          <div [hidden]="!(requestorName.errors && (requestorName.dirty && requestorName.touched))"
            class="alert alert-danger">
            <div [hidden]="!(requestorName.errors?.required)">
              User name cannot be blank
            </div>
          </div>
  
          <ng-template #requestorCustTemp let-model="item" let-index="index">
            <div>
              <span>{{model.displayName}}</span>
              <br>
              <span>{{model.mail}}</span>
            </div>
          </ng-template>
        </div>
      </div>
      <!-- <div class="add-status">
        <strong>Status</strong>
        <span class="icon-radiobutton_active icon-style" *ngIf="selectActiveStatus.isChecked"
          (click)="selectActiveStatus.isChecked = true"></span>
        <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectActiveStatus.isChecked"
          (click)="selectInActiveStatus.isChecked = false ; selectActiveStatus.isChecked = true"></span>
        <span>Active</span>
        <span class="icon-radiobutton_active icon-style" *ngIf="selectInActiveStatus.isChecked"
          (click)="selectInActiveStatus.isChecked = true" style="margin-left:10px;"></span>
        <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectInActiveStatus.isChecked"
          style="margin-left:10px;"
          (click)="selectInActiveStatus.isChecked = true ; selectActiveStatus.isChecked = false"></span>
        <span>Inactive</span>    
      </div> -->
  
  
      <div class="add-role">
        <strong>Role</strong>
        <ngx-select [items]="roleData" optionValueField="roleId" optionTextField="roleName" placeholder="Select" 
        (select)="selectRole()" [(ngModel)]="RoleSelected" [noAutoComplete]="false" (ngModelChange)="Onchange_role($event)"
         [ngModelOptions]="{standalone: true}" >
      </ngx-select>
      </div>

      <div>
        <br>
        <label> 
          <input  type="checkbox" [disabled]="this.RoleSelected ==1 || this.RoleSelected ==2" [checked]= "this.selectisrequestor.isChecked" (change)= "onCheckboxChange('requestor')" style="padding-top:10% ;  margin-left: 10px;margin-top:-3px; vertical-align: middle; position: relative; "height="30px" />
          &nbsp; Requester 
        </label>
        <label>
          <input type="checkbox" [disabled]="this.RoleSelected ==1 || this.RoleSelected ==2" [checked]= "this.selectisapprover.isChecked" (change)= "onCheckboxChange('approver')" style=" margin-left:20px;  vertical-align: middle; position: relative; " height="18px" />
          &nbsp; Approver           
        </label>
       
        <label *ngIf="isApprover && (this.RoleSelected == 3 || this.RoleSelected == 4)">
          <input type="checkbox" [disabled]="this.RoleSelected ==1 || this.RoleSelected ==2" [checked]= "this.selectisL1approver.isChecked" (change)= "onApproverChange('L1')"  style="padding-top:10% ; margin-left: 15px;margin-top:-3px; vertical-align: middle; position: relative; "height="18px" />
          &nbsp; L1
        </label>
        <label *ngIf="isApprover && (this.RoleSelected == 3 || this.RoleSelected == 4)">
          <input type="checkbox" [disabled]="this.RoleSelected ==1 || this.RoleSelected ==2" [checked]= "this.selectisL2approver.isChecked" (change)= "onApproverChange('L2')"  style="padding-top:10% ; margin-left: 40px;margin-top:-3px; vertical-align: middle; position: relative; "height="30px" />
          &nbsp; L2
        </label>      
      </div> 
    
      <!-- <div class="typeahead-wrap add-city">
        <strong>City</strong>
        <ngx-select [items]="cityData" optionValueField="cityID" optionTextField="cityName" placeholder="Select"
          (select)="selectCity()" [(ngModel)]="CitySelected" [noAutoComplete]="false"
          (ngModelChange)="OnchangeCity($event)" [ngModelOptions]="{standalone: true}" >
        </ngx-select>
      </div>
     -->
    <!-- <div [ngClass]="{'worklocaion': selectedCityId.length !== 0}">
        <div *ngFor= "let item of selectedCityId;let i = index" style="padding-bottom:5px;">
          <div class="displayOfficeName">{{item.cityName}}</div> <i class="icon-ic_delete" style="padding-left:3px;" (click)="removeCitySelected(item)"></i>
        </div>
    </div> -->
    <!-- Requestor City and Work Location - Show for Requestor when Approver is NOT selected, OR show for Admin/SuperAdmin -->
    <div *ngIf="(isRequestor && !isApprover) || (this.RoleSelected == 1 || this.RoleSelected == 2)">
      <div class="typeahead-wrap add-office">
        <strong>City</strong>
        <ngx-select id="cityID" name="office" [noAutoComplete]="false" [items]="cityData" [(ngModel)]="CitySelected"
         (select)="selectCity()" (ngModelChange)="OnchangeCity($event)" optionValueField="cityID" optionTextField="cityName"
          placeholder="Select" >
        </ngx-select> 

        <div [ngClass]="{'worklocaion': selectedCityId.length !== 0}">
          <div *ngFor="let item of selectedCityId; let i = index" style="padding-bottom:5px;">
            <div class="displayOfficeName">{{item.cityName}}</div>
            <i class="icon-ic_delete" style="padding-left:3px;" (click)="removeCitySelected(item)"></i>
          </div>
        </div>
      </div>

      <div class="typeahead-wrap add-office">
        <strong>Work Location</strong>
        <ngx-select id="officeID" name="office" [noAutoComplete]="false" [items]="officeData" [(ngModel)]="OfficeSelected"
         (select)="selectWorlLocation()" (ngModelChange)="OnchangeOffice($event)" optionValueField="officeID" optionTextField="officeName"
          placeholder="Select" >
        </ngx-select> 

        <div [ngClass]="{'worklocaion': selectedWorklocation.length !== 0}">
          <div *ngFor= "let item of selectedWorklocation;let i = index" style="padding-bottom:5px;">
          <div class="displayOfficeName">{{item.officeName}}</div> <i class="icon-ic_delete" style="padding-left:3px;" (click)="removeOfficeSelected(item)"></i>
        </div>
        </div>
      </div>

      <!-- Practice field for Admin and Super Admin (Single Selection) -->
      <div class="add-practice" *ngIf="this.RoleSelected == 1 || this.RoleSelected == 2">
        <strong>Practice</strong>
        <ngx-select [items]="practiceData" optionValueField="practiceId" optionTextField="name" 
          placeholder="Select" [(ngModel)]="PracticeSelected" 
          [noAutoComplete]="false" (ngModelChange)="Onchange_practice($event)" [ngModelOptions]="{standalone: true}">
        </ngx-select>
      </div>
    </div>

    <!-- Other roles -->
    <!-- <div *ngIf="!(RoleSelected==3)">
      <ngx-select id="office" name="office" [items]="officeData" optionValueField="officeID" optionTextField="officeName"  placeholder="Select"
      (select)="selectWorlLocation()" [(ngModel)]="OfficeSelected" [noAutoComplete]="false" 
      (ngModelChange)="OnchangeOffice($event)" >
    </ngx-select>
    </div> -->

     
      
      
    <!-- L1 and L2 Approver Sections Side by Side - Only for User and Security Supervisor -->
    <div *ngIf="isApprover && (this.RoleSelected == 3 || this.RoleSelected == 4)" style="display: flex; gap: 15px; margin-top: 15px;">
      
      <!-- L1 Approver Section (Left Side) -->
      <div *ngIf="isL1" style="flex: 1;">
        <div style="padding: 10px; background-color: #f5f5f5; border-radius: 5px; margin-bottom: 10px;">
          <h5 style="margin: 0; color: #0076A8;">L1 Approver</h5>
        </div>
        
        <!-- L1 City -->
        <div class="typeahead-wrap add-city">
          <strong>City</strong>
          <ngx-select [items]="L1cityData" optionValueField="cityID" optionTextField="cityName" 
            placeholder="Select" (select)="selectL1City()" [(ngModel)]="L1CitySelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL1City.length !== 0}">
            <div *ngFor="let item of selectedL1City" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.cityName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL1City(item)"></i>
            </div>
          </div>
        </div>

        <!-- L1 Work Location -->
        <div class="typeahead-wrap add-office">
          <strong>Work Location</strong>
          <ngx-select [items]="L1officeData" optionValueField="officeID" optionTextField="officeName" 
            placeholder="Select" (select)="selectL1WorkLocation()" [(ngModel)]="L1OfficeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL1Worklocation.length !== 0}">
            <div *ngFor="let item of selectedL1Worklocation" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.officeName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL1WorkLocation(item)"></i>
            </div>
          </div>
        </div>

        <!-- L1 Practice -->
        <div class="add-practice">
          <strong>Practice</strong>
          <ngx-select [items]="L1practiceData" optionValueField="practiceId" optionTextField="name" 
            placeholder="Select" (select)="selectL1Practice()" [(ngModel)]="L1PracticeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL1Practice.length !== 0}">
            <div *ngFor="let item of selectedL1Practice" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.name}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL1Practice(item)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- L2 Approver Section (Right Side) -->
      <div *ngIf="isL2" style="flex: 1;">
        <div style="padding: 10px; background-color: #f5f5f5; border-radius: 5px; margin-bottom: 10px;">
          <h5 style="margin: 0; color: #0076A8;">L2 Approver</h5>
        </div>
        
        <!-- L2 City -->
        <div class="typeahead-wrap add-city">
          <strong>City</strong>
          <ngx-select [items]="L2cityData" optionValueField="cityID" optionTextField="cityName" 
            placeholder="Select" (select)="selectL2City()" [(ngModel)]="L2CitySelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL2City.length !== 0}">
            <div *ngFor="let item of selectedL2City" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.cityName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL2City(item)"></i>
            </div>
          </div>
        </div>

        <!-- L2 Work Location -->
        <div class="typeahead-wrap add-office">
          <strong>Work Location</strong>
          <ngx-select [items]="L2officeData" optionValueField="officeID" optionTextField="officeName" 
            placeholder="Select" (select)="selectL2WorkLocation()" [(ngModel)]="L2OfficeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL2Worklocation.length !== 0}">
            <div *ngFor="let item of selectedL2Worklocation" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.officeName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL2WorkLocation(item)"></i>
            </div>
          </div>
        </div>

        <!-- L2 Practice -->
        <div class="add-practice">
          <strong>Practice</strong>
          <ngx-select [items]="L2practiceData" optionValueField="practiceId" optionTextField="name" 
            placeholder="Select" (select)="selectL2Practice()" [(ngModel)]="L2PracticeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL2Practice.length !== 0}">
            <div *ngFor="let item of selectedL2Practice" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.name}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL2Practice(item)"></i>
            </div>
          </div>
        </div>
      </div>

    </div>


       <div class="add-status">
        <strong>Status</strong>
        <span class="icon-radiobutton_active icon-style" *ngIf="selectActiveStatus.isChecked"
          (click)="selectActiveStatus.isChecked = true"></span>
        <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectActiveStatus.isChecked"
          (click)="selectInActiveStatus.isChecked = false ; selectActiveStatus.isChecked = true"></span>
        <span>Active</span>
        <span class="icon-radiobutton_active icon-style" *ngIf="selectInActiveStatus.isChecked"
          (click)="selectInActiveStatus.isChecked = true" style="margin-left:10px;"></span>
        <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectInActiveStatus.isChecked"
          style="margin-left:10px;"
          (click)="selectInActiveStatus.isChecked = true ; selectActiveStatus.isChecked = false"></span>
        <span>Inactive</span>    
      </div>
    </div>
  
    <div class="modal-footer">
      <button (click)="modalRef.hide()" type="button" class="button">
        Cancel
      </button>
      <button (click)="onSubmit(adduserDetails)" [disabled]="showbutton()" class="button blue" type="button">
        Add
      </button>
    </div>
</form>
